<template>
  <!-- 在线季度分析报告 -->
  <div class="analysisReport">
    <!-- <el-button type="primary" class="export" @click="downloadPage('pdfPrint',header.zykNum,header.zykName)">导出</el-button> -->
    <el-button class="export" type="primary" size="small" @click="toImage">生成PDF</el-button>

    <div class="analysisReport_box" id="pdfPrint">
      <div class="header_titles">
        <h1>职业教育“{{header.zykName}}”专业教学资源库({{header.zykNum}})</h1>
        <h1 style="margin-top: 15px;">{{yearMonthText}}</h1>
        <div class="number_time">
          <div>
            <span>状态：{{zykStatus}}</span>
            <span>时间：2022-04-01 至 2022-06-30</span>
          </div>
          <p></p>
          <p></p>
        </div>
      </div>

      <div class="division">
        <span>1. 当前资源库用户情况</span>
      </div>

      <div class="chart_box">
        <h4>1.1 当前资源库用户情况</h4>
        <p> 当前该资源库的用户数{{resourceLibrary.total}}人，
          其中教师{{resourceLibrary.teacherNum}}人;
          学生{{resourceLibrary.studentNum}}人；
          企业用户{{resourceLibrary.enterpriseNum}}人；
          社会学习者{{resourceLibrary.socialNum}}人；
          其他{{resourceLibrary.otherNum}}人；
          具体如图 1 所示。</p>
        <div class="standards_content echartsHeight">
          <circularChart :refId="'resourceLibraryChart'" :datas='resourceLibrary.dataList' :colorName='1' :innerText="'数量'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'60%'" :circleSize="80"></circularChart>
        </div>
        <div class="chart_name">图1 当前资源库用户情况</div>
      </div>

      <div class="chart_box">
        <h4>1.2 当前资源库建设单位注册用户情况</h4>
        <p>
          当前该资源库教师用户{{resourceLibrary.teacherNum}}人，其中主持单位的教师用户{{userCountUnit.zcteacherNum}}人，参建单位的教师用户{{userCountUnit.teacherNum}}人;
          学生用户{{resourceLibrary.studentNum}}人，其中主持单位的学生用户{{userCountUnit.zcstudentNum}}人，参建单位的学生用户{{userCountUnit.studentNum}}人，具体如图 2 所示。
        </p>
        <div class="layout">
          <div class="standards_content echartsHeight">
            <circularChart :refId="'userCountUnitChart1'" :datas='userCountUnit.teacherList' :colorName='1' :innerText="'数量'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'60%'" :circleSize="65"></circularChart>
          </div>
          <div class="standards_content echartsHeight">
            <circularChart :refId="'userCountUnitChart2'" :datas='userCountUnit.studentList' :colorName='1' :innerText="'数量'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'60%'" :circleSize="65"></circularChart>
          </div>
        </div>
        <div class="chart_name">图2 当前资源库建设单位注册用户情况</div>
      </div>

      <div class="chart_box">
        <h4>1.3 当前资源库资源建设情况</h4>
        <p> 当前该资源库的素材资源总数{{typeDistribution.total}}个，
          其中文本类{{typeDistribution.wbNumber}}个;
          图形图像类{{typeDistribution.txtxNumber}}个；
          视频类{{typeDistribution.spNumber}}个；
          动画类{{typeDistribution.dhNumber}}个；
          虚拟仿真类{{typeDistribution.xnfzNumber}}个；
          微课类{{typeDistribution.wkNumber}}个；
          音频类{{typeDistribution.ypNumber}}个；
          ppt和富媒体等{{typeDistribution.pptNumber+typeDistribution.kjNumber+typeDistribution.fmtNumber}}个；
          其他{{typeDistribution.qtNumber}}个；
          具体如图 3 所示。</p>
        <div class="standards_content echartsHeight">
          <circularChart :refId="'typeDistributionChart'" :datas='typeDistribution.dataList' :colorName='2' :innerText="'数量'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'60%'" :circleSize="80"></circularChart>
        </div>
        <div class="chart_name">图3 资源库素材资源类型分布</div>
      </div>

      <div class="chart_box">
        <h4>1.4 当前资源库标准化课程建设与应用情况</h4>
        <p> 当前该资源库建有标准化课程{{standardization.courseBzNum}}门，按访问量排名前10名如图 4 所示。</p>
        <div class="standards_content echartsHeight">
          <tcolumnarChart :refId="'standardizationChart'" :datas='standardization.dataList' :transverseData='standardization.transverseData' :colorList='standardization.colorList' :innerText="'单位：次'" :seriesColor='true' :isShowTextColor="true"></tcolumnarChart>
        </div>
        <div class="chart_name">图4 该资源库标准化课程访问量排名</div>
        <div class="notes">（注1：标准化课程指资源库建设团队按照《指南》要求建设和提供的，涵盖课程基本知识点和技能点，能够适应
          全国同类和相近专业在线教学基本需要的结构化课程。标准化课程的正确性、逻辑性、权威性由资源库建设团队保
          证。个性化课程指教师在使用资源库过程中，结合自身实际教学需要和学生特点，对标准化课程进行改造、补充、
          重构后形成的个性化课程。个性化课程的正确性、逻辑性由建课教师自行保障。注2：如标准化课程或个性化课程
          显示为0，表明该资源库在课程标注上不规范，需要在资源库运行平台中对课程分类重新标注。）</div>
      </div>

      <div class="chart_box">
        <h4>1.5 当前资源库用户行为类型分布</h4>
        <p> 该资源库用户行为活动总量为{{behaviorTypes.total}}次，其中
          课程模块{{behaviorTypes.courseModule}}次，资源素材模块{{behaviorTypes.resourceModule}}次，
          论坛模块{{behaviorTypes.forumModule}}次，作业模块{{behaviorTypes.taskModule}}次，
          考试模块{{behaviorTypes.examinationModule}}次，其他模块{{behaviorTypes.otherModule}}次，
          具体如图 5所示。</p>
        <div class="standards_content echartsHeight">
          <circularChart :refId="'behaviorTypesChart'" :datas='behaviorTypes.dataList' :colorName='1' :innerText="'数量'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'60%'" :circleSize="80"></circularChart>
        </div>
        <div class="chart_name">图5 资源库用户行为类型分布</div>
      </div>

      <div class="chart_box">
        <h4>1.6 资源库无活动数据情况</h4>
        <p> 该资源库实名教师总数{{resourcePool.realTeacher}}人，其中无活动教师 {{resourcePool.countTeacher}}人；
          实名学生总数{{resourcePool.realStudent}}人，其中无活动学生{{resourcePool.countStudent}}人；
          资源总数{{typeDistribution.total}}条，其中无访问资源{{resourcePool.countResource}}条；请继续关注应用情况，监督其深入应用，具体如图6所示。</p>
        <div class="speed">
          <el-row>
            <el-col :span="8">
              <div>本资源库实名教师中无活动教师占比:</div>
            </el-col>
            <el-col :span="16">
              <el-progress :text-inside="true" :stroke-width="40" :format="teacherFormat" :percentage="waterDrop.teacher" color="#3B86FF"></el-progress>
            </el-col>

            <el-col :span="8">
              <div>本资源库实名学生中无活动学生占比:</div>
            </el-col>
            <el-col :span="16">
              <el-progress :text-inside="true" :stroke-width="40" :format="studentFormat" :percentage="waterDrop.student" color="#63D0FF"></el-progress>
            </el-col>

            <el-col :span="8">
              <div>本资源库无访问资源占比:</div>
            </el-col>
            <el-col :span="16">
              <el-progress :text-inside="true" :stroke-width="40" :format="resourceFormat" :percentage="waterDrop.resource" color="#BBA8FF"></el-progress>
            </el-col>
          </el-row>
        </div>
        <div class="chart_name">图6 资源库无活动数据情况</div>
      </div>

      <div class="division">
        <span>2. 本季度资源库新增情况</span>
      </div>

      <div class="chart_box">
        <h4>2.1 本季度用户新增情况</h4>
        <p> 该资源库本季度新增教师用户数{{usersMonth.teacherNum}}人，新增学生用户数{{usersMonth.studentNum}}人，新增企业用户数{{usersMonth.enterpriseNum}}人，新增社会学习者用户数{{usersMonth.socialNum}}人，新增其他用户数{{usersMonth.otherNum}}人，具体如图 7 所示。</p>
        <div class="standards_content echartsHeight">
          <discountChart :refId="'usersMonthChart'" :datas='usersMonth.dataList' :transverseData='usersMonth.transverseData' :colorList='usersMonth.colorList' :legendList="usersMonth.legendList" :innerText="'单位：人'" :isShowTextColor="true"></discountChart>
        </div>
        <div class="chart_name">图7 本季度用户新增情况</div>
      </div>

      <div class="chart_box">
        <p> 该资源库本季度新增用户中，主持院校新增教师数{{majorUser.teacher}}人，参建院校新增教师数{{majorUser.cjteacher}}人，
          主持院校新增学生数{{majorUser.student}}人，参建院校新增学生数{{majorUser.cjstudent}}人，
          主持院校与参建院校新增占比情况，如下图8所示。</p>
        <div class="speed">
          <el-row>
            <el-col :span="6">
              <div>主持院校新增教师占比:</div>
            </el-col>
            <el-col :span="18">
              <el-progress :text-inside="true" :stroke-width="40" :format="majorteacherFormat" :percentage="waterDrop.majorteacher" color="#3B86FF"></el-progress>
            </el-col>

            <el-col :span="6">
              <div>参建院校新增教师占比：</div>
            </el-col>
            <el-col :span="18">
              <el-progress :text-inside="true" :stroke-width="40" :format="unitteacherFormat" :percentage="waterDrop.unitteacher" color="#63D0FF"></el-progress>
            </el-col>

            <el-col :span="6">
              <div>主持院校新增学生占比：</div>
            </el-col>
            <el-col :span="18">
              <el-progress :text-inside="true" :stroke-width="40" :format="majorstudentFormat" :percentage="waterDrop.majorstudent" color="#BBA8FF"></el-progress>
            </el-col>

            <el-col :span="6">
              <div>参建院校学生新增占比：</div>
            </el-col>
            <el-col :span="18">
              <el-progress :text-inside="true" :stroke-width="40" :format="unitstudentFormat" :percentage="waterDrop.unitstudent" color="#7F88FE"></el-progress>
            </el-col>
          </el-row>
        </div>
        <div class="chart_name">图8 主持院校与参建院校新增用户占比情况</div>
      </div>

      <div class="chart_box">
        <p> 该资源库本季度实名教师中无活动教师{{ben.noAccessTeacher}}人，占教师总数{{parseFloat(((resourcePool.countTeacher/resourceLibrary.teacherNum)*100).toFixed(2))}}%，
          实名学生中无活动学生{{ben.noAccessStudent}}人，占学生总数{{parseFloat(((resourcePool.countStudent/resourceLibrary.studentNum)*100).toFixed(2))}}%，如下图9所示。
        </p>
        <div class="standards_content echartsHeight">
          <vcolumnarChart :refId="'verticalBarChart'" :datas='verticalBar.dataList' :legendList="verticalBar.legendList" :transverseData='verticalBar.transverseData' :colorList='verticalBar.colorList' :seriesColor='true' :innerText="'单位：人'" :labelShow="true" :axisLabelInterval="true" :isShowTextColor="true"></vcolumnarChart>
        </div>
        <div class="chart_name">图9 资源库无活动师生数据变化情况</div>
      </div>

      <div class="chart_box">
        <h4>2.2 本季度素材资源新增情况</h4>
        <p> 该资源库本季度新增素材资源{{resourcesMonth.total}}条，具体如图 10 所示。</p>
        <div class="standards_content echartsHeight">
          <circularChart :refId="'resourcesMonthChart'" :datas='resourcesMonth.dataList' :colorName='1' :innerText="'数量'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'60%'" :circleSize="80"></circularChart>
        </div>
        <div class="chart_name">图10 资源库各类型素材资源新增情况</div>
      </div>

      <div class="chart_box">
        <h4></h4>
        <p>
          该资源库本季度无访问资源数{{ben.noAccessResource}}个，
          无访问资源数占总素材资源数{{ben.noAccessResourceList}}，
          较上季度<span v-if="Math.sign(LastMoth.noAccessResource - ben.noAccessResource) > 0">减少{{Math.abs(LastMoth.noAccessResource - ben.noAccessResource)}}</span>
          <span v-else>增加{{Math.abs(LastMoth.wufagnwennumber)}}</span>个，
          具体如图11 所示。
        </p>
        <div class="speed" ref="picture11">
          <el-row>
            <el-col :span="5">
              <div>上季度无访问资源占比:</div>
            </el-col>
            <el-col :span="19">
              <el-progress :text-inside="true" :stroke-width="40" :format="lastresourceFormat" :percentage="waterDrop.lastresource" color="#3B86FF"></el-progress>
            </el-col>

            <el-col :span="5">
              <div>本季度无访问资源占比:</div>
            </el-col>
            <el-col :span="19">
              <el-progress :text-inside="true" :stroke-width="40" :format="resourceFormat" :percentage="waterDrop.resource" color="#63D0FF"></el-progress>
            </el-col>
          </el-row>
        </div>
        <div class="chart_name divorced">图11 资源库无访问资源变化情况</div>
      </div>

      <div class="chart_box">
        <h4>2.3 本季度课程新增情况</h4>
        <p>本季度<span v-for="(item,index) in coursesMonth.dataList" :key="index">{{item.name}}新增{{item.value}}门，</span>具体如图12所示。</p>
        <div class="standards_content echartsHeight">
          <circularChart :refId="'lastcoursesMonthChart'" :datas='coursesMonth.dataList' :colorName='1' :innerText="'数量'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'60%'" :circleSize="80"></circularChart>
        </div>
        <div class="chart_name divorced">图12 课程新增变化情况</div>
      </div>

      <div class="division">
        <span>3. 本季度资源库应用情况</span>
      </div>

      <div class="chart_box">
        <h4>3.1 本季度资源访问情况</h4>
        <p> 该资源库本季度资源访问数{{accessMonth.total}}次，具体如图 13 所示。</p>
        <div class="standards_content echartsHeight">
          <discountChart :refId="'accessMonthChart'" :datas='accessMonth.dataList' :transverseData='accessMonth.transverseData' :colorList='accessMonth.colorList' :legendList="accessMonth.legendList" :innerText="'单位：次'" :isShowTextColor="true"></discountChart>
        </div>
        <div class="chart_name">图13 本季度资源访问情况</div>
      </div>

      <div class="chart_box">
        <h4>3.2 本季度课程访问情况</h4>
        <p> 该资源库本季度课程访问数{{visitsMonth.total}}次，具体如图 14 所示。</p>
        <div class="standards_content echartsHeight">
          <discountChart :refId="'visitsMonthChart'" :datas='visitsMonth.dataList' :transverseData='visitsMonth.transverseData' :colorList='visitsMonth.colorList' :legendList="visitsMonth.legendList" :innerText="'单位：次'" :isShowTextColor="true"></discountChart>
        </div>
        <div class="chart_name">图14 本季度课程访问情况</div>
      </div>

      <div class="chart_box">
        <h4>3.3 本季度用户访问情况</h4>
        <p> 该资源库本季度用户访问数{{userAccessMonth.total}}人次，具体访问趋势如图 15 所示。</p>
        <div class="standards_content echartsHeight">
          <discountChart :refId="'userAccessMonthChart'" :datas='userAccessMonth.dataList' :transverseData='userAccessMonth.transverseData' :colorList='userAccessMonth.colorList' :legendList="userAccessMonth.legendList" :innerText="'单位：人次'" :isShowTextColor="true"></discountChart>
        </div>
        <div class="chart_name">图15 本季度用户访问情况</div>
      </div>

      <div class="chart_box">
        <h4></h4>
        <p> 用户访问时间段分布如图16所示。</p>
        <div class="standards_content echartsHeight">
          <discountChart :refId="'behaviorUserChart'" :datas='behaviorUser.dataList' :transverseData='behaviorUser.transverseData' :colorList='behaviorUser.colorList' :legendList="behaviorUser.legendList" :innerText="'单位：人次'" :isShowTextColor="true"></discountChart>
        </div>
        <div class="chart_name">图16 本月用户访问时间段分布</div>
      </div>
      <el-backtop></el-backtop>
    </div>
  </div>
</template>

<script>
import circularChart from '@/components/chart/circularChart.vue' //引入圆形图表
import vcolumnarChart from '@/components/chart/vcolumnarChart.vue' //引入竖柱状图图表
import tcolumnarChart from '@/components/chart/tcolumnarChart.vue' //引入横柱图图表
import discountChart from '@/components/chart/discountChart.vue' //引入折现图图表
import waterDropChart from '@/components/chart/waterDropChart.vue' //引入水滴图图表

export default {
  components: {
    circularChart,
    vcolumnarChart,
    tcolumnarChart,
    discountChart,
    waterDropChart
  },
  data() {
    return {
      year: '',
      yearAndMonthly: '',
      yearMonthText: '',
      zykStatus: '已立项',
      colorList: ['#3B85FB', '#FD398E', '#8B68F1', '#EE6F5E', '#E0D35F', '#5470C6', '#DE7E4B', '#DE524B'],  //柱状图或折线图的颜色
      header: {
        zykName: '',
        zykNum: '',
        startTime: '',
        endTime: '',
        yearOrMonth: ''
      },
      resourceLibrary: {  //图1 当前资源库用户情况
        dataList: [],
        total: 0,
        teacherNum: 0,
        studentNum: 0,
        enterpriseNum: 0,
        socialNum: 0,
        otherNum: 0,
      },
      userCountUnit: {  //图2 当前资源库参建单位注册用户情况（主持单位学生 + 老师，参建单位用户人数）
        teacherList: [],
        studentList: [],
        teacherNum: 0,
        studentNum: 0,
        zcteacherNum: 0,
        zcstudentNum: 0,
      },

      typeDistribution: {  //图3 资源库素材资源类型分布
        dataList: [],
        spNumber: 0,
        dhNumber: 0,
        txtxNumber: 0,
        xnfzNumber: 0,
        wbNumber: 0,
        wkNumber: 0,
        ypNumber: 0,
        kjNumber: 0,
        pptNumber: 0,
        fmtNumber: 0,
        qtNumber: 0,
        total: 0
      },
      standardization: {  //图4 该资源库标准化课程活跃用户排名
        dataList: [],
        transverseData: [],
        colorList: [],
        courseBzNum: 0
      },
      behaviorTypes: {   //图5 资源库用户行为类型分布
        dataList: [],
        total: 0,
        loginModule: 0,
        courseModule: 0,
        resourceModule: 0,
        forumModule: 0,
        taskModule: 0,
        examinationModule: 0,
        otherModule: 0
      },

      waterDrop: {
        teacher: 0,         //图6 资源库无活动数据情况
        student: 0,         //图6 资源库无活动数据情况
        resource: 0,        //图6 资源库无活动数据情况

        // lastresource: 0,    //图11 资源库无访问资源较上月变化情况
        majorteacher: 0,    //图8 主持院校与参建院校新增占比情况
        majorstudent: 0,    //图8 主持院校与参建院校新增占比情况
        unitteacher: 0,     //图8 主持院校与参建院校新增占比情况
        unitstudent: 0,     //图8 主持院校与参建院校新增占比情况

        teacherNum: 0,
        studentNum: 0,
        resourceNum: 0,
        lastresourceNum: 0,
        majorteacherNum: 0,
        majorstudentNum: 0,
        unitteacherNum: 0,
        unitstudentNum: 0,
      },
      usersMonth: {  //图7 本月用户新增情况
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: [],
        teacherNum: 0,
        studentNum: 0,
        enterpriseNum: 0,
        socialNum: 0,
        otherNum: 0,
        total: 0
      },
      verticalBar: {   //图9 资源库无活动师生数据变化情况
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: []
      },
      resourcesMonth: {  //图10 资源库各类型素材资源新增情况
        dataList: [],
        total: 0
      },
      coursesMonth: {  //图12 本月课程新增情况
        dataList: [],
        total: 0,
        standardNum: 0,
        personalityNum: 0
      },
      accessMonth: {  //图13 本月资源访问情况
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: [],
        total: 0
      },
      visitsMonth: {  //图14 本月课程访问情况
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: [],
        total: 0
      },
      userAccessMonth: {  //图15 本月用户访问情况
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: [],
        total: 0
      },
      behaviorUser: {  //图16 本月用户访问时间段分布
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: [],
        total: 0
      },


      resourcePool: {  //图6 资源库无活动数据情况,图9 资源库无活动师生数据变化情况,图11 资源库无访问资源较上月变化情况
        countTeacher: 0,
        countStudent: 0,
        realTeacher: 0,
        realStudent: 0,
        countResource: 0
      },

      majorUser: {  //图8 主持院校与参建院校新增占比情况
        teacher: 0,
        student: 0,
        cjteacher: 0,
        cjstudent: 0
      },
      lastMonth: {  //图9 资源库无活动师生数据变化情况,图11 资源库无访问资源较上月变化情况,图12 本月课程新增情况
        noAccessTeacher: 0,//无活动教师
        noAccessStudent: 0,//无活动学生
        noAccessResource: 0,//无活动资源
        videoNum: 0,
        animationNum: 0,
        graphicImageNum: 0,
        virtualSimulationNum: 0,
        textNum: 0,
        smallCourseNum: 0,
        shenyangNum: 0,
        coursewareNum: 0,
        pptNum: 0,
        mediaNum: 0,
        otherNum: 0,
        standardNum: 0,//标准化课程
        personalityNum: 0,//个性化课程
        resourceTotal: 0
      },
      LastMoth: {
        dataList: [],
        wufagnwennumber: 0,
        noAccessTeacher: 0,
        noAccessStudent: 0,
        noAccessResource: 0,

        noAccessResourceList: 0
      },
      ben: {
        dataList: [],
        wufagnwennumber: 0,
        noAccessTeacher: 0,
        noAccessStudent: 0,
        noAccessResource: 0,
        noAccessResourceList: 0
      },
      loading: '',    //是否导出加载中
    }
  },
  created() {
    if (this.$route.query) {
      this.$route.query.zykName = decodeURIComponent(this.$route.query.zykName)
      var year = this.$route.query.yearOrMonth
      var monthly = this.$route.query.yearOrMonth
      this.$route.query.startTime = year + '-' + monthly + '-' + 1
      this.$route.query.endTime = year + '-' + monthly + '-' + new Date(year, monthly, 0).getDate()
      this.header = this.$route.query
      this.year = year + '-' + monthly
      this.yearAndMonthly = this.$route.query.yearOrMonth
      this.yearMonthText = 2022 + '年' + '第二季度' + '运行数据分析报告'
    }

    this.getZykStatus()
    this.resourceLibraryDom();   // 当前资源库用户情况
    this.getUserCountUnitDom()  // 当前资源库建设单位注册用户情况
    this.typeDistributionDom();
    this.standardizationDom();
    this.behaviorTypesDom();
    this.shanggeyue();       //  获取上个月资源
    setTimeout(() => {
      this.bengeyue()
    }, 1000);

    this.resourcePoolDom();
    this.usersMonthDom();

    this.resourcesMonthDom();
    this.coursesMonthDom();
    this.accessMonthDom();
    this.visitsMonthDom();
    this.userAccessMonthDom();
    this.getLrmv2MonthBehaviorUserCourseLog();
  },
  methods: {
    // 导出月报
    toImage() {
      this.loading = this.$loading({
        lock: true,
        text: '正在导出中，请稍后...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      this.$axios.post(this.$apiurls.exportMonthReport, {
        courseName: "",
        isAll: false,
        month: this.yearAndMonthly,
        reportType: 0,
        zykId: sessionStorage.getItem('zykId'),
        zykName: this.header.zykName,
        zykNum: this.header.zykNum
      }, {
        loading: false,
      }).then((res) => {
        if (res) {
          window.open(res.data)
          this.loading.close();
        }
      }).catch(() => {
        this.loading.close();
      })
    },

    // 获取资源库状态
    getZykStatus() {
      this.$axios.post(this.$apiurls.report_monthly_getZykStatus, sessionStorage.getItem('zykId'), {
        loading: false,
      }).then((res) => {
        if (res) {
          this.zykStatus = res.data
        }
      });
    },

    // 图1 当前资源库用户情况
    resourceLibraryDom() {
      this.$axios.post(this.$apiurls.report_monthly_resourceLibrary, {
        loading: false,
      }).then((res) => {

        if (res) {
          let arrList = []
          arrList.push({
            name: '教师',
            value: res.data.teacherNum
          }, {
            name: '学生',
            value: res.data.studentNum
          }, {
            name: '企业用户',
            value: res.data.enterpriseNum
          }, {
            name: '社会学习者',
            value: res.data.socialNum
          }, {
            name: '其他',
            value: res.data.otherNum
          })
          this.resourceLibrary.total = res.data.total
          this.resourceLibrary.teacherNum = res.data.teacherNum
          this.resourceLibrary.studentNum = res.data.studentNum
          this.resourceLibrary.enterpriseNum = res.data.enterpriseNum
          this.resourceLibrary.socialNum = res.data.socialNum
          this.resourceLibrary.otherNum = res.data.otherNum
          this.resourceLibrary.dataList = arrList
        }
      })
    },


    //图2 当前资源库建设单位注册用户情况
    getUserCountUnitDom() {
      this.$axios.post(this.$apiurls.report_monthly_getUserCountUnit, {
        loading: false,
      }).then((res) => {
        if (res) {
          var studentList = [];
          var teacherList = [];
          this.userCountUnit.teacherNum = res.data.teacherNum;
          this.userCountUnit.studentNum = res.data.studentNum;
          this.userCountUnit.zcteacherNum = res.data.enterpriseNum;
          this.userCountUnit.zcstudentNum = res.data.socialNum;

          teacherList.push({
            name: '主持单位教师',
            value: res.data.enterpriseNum
          }, {
            name: '参建单位教师',
            value: res.data.teacherNum
          });

          studentList.push({
            name: '主持单位学生',
            value: res.data.socialNum
          }, {
            name: '参建单位学生',
            value: res.data.studentNum
          });
          this.userCountUnit.studentList = studentList;
          this.userCountUnit.teacherList = teacherList;
        }
      });
    },

    // 图3 资源库素材资源类型分布
    typeDistributionDom() {
      this.$axios.post(this.$apiurls.report_year_getStatResourceDataEntity, 1, {
        loading: false,
      }).then((res) => {

        if (res) {
          console.log(res);
          var arrList = []
          arrList.push({
            name: '视频类',
            value: res.data.videoNum
          }, {
            name: '动画类',
            value: res.data.animationNum
          }, {
            name: '图形图像类',
            value: res.data.graphicImageNum
          }, {
            name: '虚拟仿真类',
            value: res.data.virtualSimulationNum
          }, {
            name: '文本类',
            value: res.data.textNum
          }, {
            name: '微课类',
            value: res.data.smallCourseNum
          }, {
            name: '音频类',
            value: res.data.shenyangNum
          }, {
            name: 'ppt和富媒体等',
            value: res.data.pptNum + res.data.coursewareNum + res.data.mediaNum
          }, {
            name: '其他',
            value: res.data.otherNum
          })
          this.typeDistribution.spNumber = res.data.videoNum
          this.typeDistribution.dhNumber = res.data.animationNum
          this.typeDistribution.txtxNumber = res.data.graphicImageNum
          this.typeDistribution.xnfzNumber = res.data.virtualSimulationNum
          this.typeDistribution.wbNumber = res.data.textNum
          this.typeDistribution.wkNumber = res.data.smallCourseNum
          this.typeDistribution.ypNumber = res.data.shenyangNum
          this.typeDistribution.kjNumber = res.data.coursewareNum
          this.typeDistribution.pptNumber = res.data.pptNum
          this.typeDistribution.fmtNumber = res.data.mediaNum
          this.typeDistribution.qtNumber = res.data.otherNum
          this.typeDistribution.total = res.data.total
          this.typeDistribution.dataList = arrList
        }
      });
    },

    // 图4 该资源库标准化课程访问量排名
    standardizationDom() {
      this.$axios.post(this.$apiurls.report_monthly_standardization, {
        loading: false,
      }).then((res) => {

        if (res) {
          var name = []
          var value = []
          for (let i = 0; i < res.data.lrmv2UserResourceCourseRankingLogEntities.length; i++) {
            name.push(res.data.lrmv2UserResourceCourseRankingLogEntities[i].name)
            value.push(res.data.lrmv2UserResourceCourseRankingLogEntities[i].num)
          }
          this.standardization.dataList = value
          this.standardization.transverseData = name
          this.standardization.colorList = this.colorList
          this.standardization.courseBzNum = res.data.courseBzNum
        }
      });
    },

    // 图5 资源库用户行为类型分布
    behaviorTypesDom() {
      this.$axios.post(this.$apiurls.report_monthly_behaviorTypes, {
        loading: false,
      }).then((res) => {
        if (res) {
          var arrList = []
          arrList.push({
            name: '课程模块',
            value: res.data.courseModule
          }, {
            name: '资源素材模块',
            value: res.data.resourceModule
          }, {
            name: '论坛模块',
            value: res.data.forumModule
          }, {
            name: '作业模块',
            value: res.data.taskModule
          }, {
            name: '考试模块',
            value: res.data.examinationModule
          }, {
            name: '其他模块',
            value: res.data.otherModule
          })
          this.behaviorTypes.loginModule = res.data.loginModule
          this.behaviorTypes.courseModule = res.data.courseModule
          this.behaviorTypes.resourceModule = res.data.resourceModule
          this.behaviorTypes.forumModule = res.data.forumModule
          this.behaviorTypes.taskModule = res.data.taskModule
          this.behaviorTypes.examinationModule = res.data.examinationModule
          this.behaviorTypes.otherModule = res.data.otherModule
          this.behaviorTypes.total = res.data.total
          this.behaviorTypes.dataList = arrList
        }
      });
    },
    // 图6 资源库无活动数据情况
    resourcePoolDom() {
      this.$axios.post(this.$apiurls.report_monthly_resourcePool, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.resourcePool = res.data
          this.waterDrop.teacher = (this.resourcePool.countTeacher / this.resourcePool.realTeacher * 100) ? Math.round(this.resourcePool.countTeacher / this.resourcePool.realTeacher * 100) : 0
          this.waterDrop.student = (this.resourcePool.countStudent / this.resourcePool.realStudent * 100) ? Math.round(this.resourcePool.countStudent / this.resourcePool.realStudent * 100) : 0
          this.waterDrop.resource = (this.ben.noAccessResource / this.typeDistribution.total * 100) ? Math.round(this.ben.noAccessResource / this.typeDistribution.total * 100) : 0
          this.waterDrop.teacherNum = (this.resourcePool.countTeacher / this.resourcePool.realTeacher * 100) ? (this.resourcePool.countTeacher / this.resourcePool.realTeacher * 100).toFixed(2) : 0
          this.waterDrop.studentNum = (this.resourcePool.countStudent / this.resourcePool.realStudent * 100) ? (this.resourcePool.countStudent / this.resourcePool.realStudent * 100).toFixed(2) : 0
          this.waterDrop.resourceNum = (this.resourcePool.countResource / this.typeDistribution.total * 100) ? (this.resourcePool.countResource / this.typeDistribution.total * 100).toFixed(2) : 0
          this.getLrmv2MonthUserCourseResource(); 1
        }
      });
    },
    // 图7 本月用户新增情况
    usersMonthDom() {
      this.$axios.post(this.$apiurls.quarterly_monthly_getQuarterZykAdd, { type: 1, year: 2022, quarter: 2 }, {
        loading: false,
      }).then((res) => {

        if (res) {
          var transverse = []
          var teacherDate = []
          var studentDate = []
          var enterpriseDate = []
          var socialDate = []
          var otherDate = []

          var teacherNum = 0
          var studentNum = 0
          var enterpriseNum = 0
          var socialNum = 0
          var otherNum = 0
          for (let i = 0; i < res.data.teacher.length; i++) {
            transverse.push(res.data.teacher[i].date)
            teacherDate.push(res.data.teacher[i].num)
            teacherNum += parseFloat(res.data.teacher[i].num)
          }
          for (let i = 0; i < res.data.student.length; i++) {
            studentDate.push(res.data.student[i].num)
            studentNum += parseFloat(res.data.student[i].num)
          }
          for (let i = 0; i < res.data.enterprise.length; i++) {
            enterpriseDate.push(res.data.enterprise[i].num)
            enterpriseNum += parseFloat(res.data.enterprise[i].num)
          }
          for (let i = 0; i < res.data.social.length; i++) {
            socialDate.push(res.data.social[i].num)
            socialNum += parseFloat(res.data.social[i].num)
          }
          for (let i = 0; i < res.data.other.length; i++) {
            otherDate.push(res.data.other[i].num)
            otherNum += parseFloat(res.data.other[i].num)
          }
          this.usersMonth.dataList = [teacherDate, studentDate, enterpriseDate, socialDate, otherDate]
          this.usersMonth.transverseData = transverse
          this.usersMonth.legendList = ['教师', '学生', '企业用户', '社会学习者']
          this.usersMonth.colorList = this.colorList
          this.usersMonth.teacherNum = teacherNum
          this.usersMonth.studentNum = studentNum
          this.usersMonth.enterpriseNum = enterpriseNum
          this.usersMonth.socialNum = socialNum
          this.usersMonth.otherNum = otherNum
          this.usersMonth.total = teacherNum + studentNum + enterpriseNum + socialNum + otherNum
          this.getMajorUser()
        }
      });
    },

    //图8 主持院校与参建院校新增占比情况
    getMajorUser() {
      this.$axios.post(this.$apiurls.quarterly_monthly_getQuarterMajorUser, { year: 2022, quarter: 2 }, {
        loading: false,
      }).then((res) => {

        if (res) {
          this.majorUser.teacher = res.data.teacher ? res.data.teacher : 0
          this.majorUser.student = res.data.student ? res.data.student : 0
          this.majorUser.cjteacher = res.data.cjteacher ? res.data.cjteacher : 0
          this.majorUser.cjstudent = res.data.cjstudent ? res.data.cjstudent : 0

          this.waterDrop.majorteacher = this.usersMonth.teacherNum ? Math.round(this.majorUser.teacher / this.usersMonth.teacherNum * 100) : 0
          this.waterDrop.majorstudent = this.usersMonth.studentNum ? Math.round(this.majorUser.student / this.usersMonth.studentNum * 100) : 0
          this.waterDrop.unitteacher = this.usersMonth.teacherNum ? Math.round(this.majorUser.cjteacher / this.usersMonth.teacherNum * 100) : 0
          this.waterDrop.unitstudent = this.usersMonth.studentNum ? Math.round(this.majorUser.cjstudent / this.usersMonth.studentNum * 100) : 0

          this.waterDrop.majorteacherNum = this.usersMonth.teacherNum ? (this.majorUser.teacher / this.usersMonth.teacherNum * 100).toFixed(2) : 0
          this.waterDrop.majorstudentNum = this.usersMonth.studentNum ? (this.majorUser.student / this.usersMonth.studentNum * 100).toFixed(2) : 0
          this.waterDrop.unitteacherNum = this.usersMonth.teacherNum ? (this.majorUser.cjteacher / this.usersMonth.teacherNum * 100).toFixed(2) : 0
          this.waterDrop.unitstudentNum = this.usersMonth.studentNum ? (this.majorUser.cjstudent / this.usersMonth.studentNum * 100).toFixed(2) : 0
        }
      });
    },
    // 上季度资源库各类型素材资源新增情况
    shanggeyue() {
      this.$axios.post(this.$apiurls.quarterly_monthly_getLrmv2QuarterUserCourseResource, { year: 2022, quarter: 2 }, {
        loading: false,
      }).then((res) => {
        this.LastMoth.dataList = res.data
        this.LastMoth.wufagnwennumber = this.ben.noAccessResource - res.data.noAccessResource
        this.LastMoth.noAccessStudent = res.data.noAccessStudent
        this.LastMoth.noAccessTeacher = res.data.noAccessTeacher
        this.LastMoth.noAccessResource = res.data.noAccessResource
        this.LastMoth.noAccessResourceList = ((res.data.noAccessResource / this.typeDistribution.total) * 100).toFixed(2)
      })
    },
    // 本季度资源库各类型素材资源新增情况
    bengeyue() {
      this.$axios.post(this.$apiurls.quarterly_monthly_getLrmv2QuarterUserCourseResource, { year: 2022, quarter: 3 }, {
        loading: false,
      }).then((res) => {
        this.ben.dataList = res.data
        this.ben.noAccessStudent = res.data.noAccessStudent
        this.ben.noAccessTeacher = res.data.noAccessTeacher
        this.ben.noAccessResource = res.data.noAccessResource
        this.ben.noAccessResourceList = ((res.data.noAccessResource / this.typeDistribution.total) * 100).toFixed(2)

      })
    },
    // 图9 资源库无活动师生数据变化情况,图11 资源库无访问资源较上月变化情况,图12 本月课程新增情况
    getLrmv2MonthUserCourseResource() {
      this.$axios.post(this.$apiurls.report_monthly_resourcePool, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.lastMonth = res.data
          this.verticalBar.dataList = [[this.ben.noAccessTeacher, this.ben.noAccessStudent], [this.LastMoth.noAccessTeacher, this.LastMoth.noAccessStudent]]
          this.verticalBar.transverseData = ['无活动教师', '无活动学生']
          this.verticalBar.colorList = this.colorList
          this.verticalBar.legendList = ['本季度', '上季度']

          // 上季度无访问资源占比
          this.waterDrop.lastresource = ((this.LastMoth.noAccessResource / this.typeDistribution.total) * 100).toFixed(2) ? Math.round((this.LastMoth.noAccessResource / this.typeDistribution.total) * 100).toFixed(2) : 0
          let num = parseFloat(this.waterDrop.lastresource)
          this.waterDrop.lastresource = num
        }
      });
    },

    // 图10 本月资源库各类型素材资源新增情况
    resourcesMonthDom() {
      this.$axios.post(this.$apiurls.quarterly_monthly_getQuarterZykAdd, { type: 2, year: 2022, quarter: 2 }, {
        loading: false,
      }).then((res) => {
        if (res) {
          var arrList = []
          var number = 0
          var total = 0
          for (let i = 0; i <= res.data.length - 1; i++) {
            var detailed_type = "";
            switch (res.data[i].detailed_type) {
              case 1:
                detailed_type = "视频";
                arrList.push({
                  name: detailed_type,
                  value: res.data[i].num
                })
                break;
              case 2:
                detailed_type = "动画";
                arrList.push({
                  name: detailed_type,
                  value: res.data[i].num
                })
                break;
              case 3:
                detailed_type = "图形图像";
                arrList.push({
                  name: detailed_type,
                  value: res.data[i].num
                })
                break;
              case 4:
                detailed_type = "虚拟仿真";
                // arrList.push({
                //   name: detailed_type,
                //   value: res.data[i].num
                // })
                break;
              case 5:
                detailed_type = "文本";
                // arrList.push({
                //   name: detailed_type,
                //   value: res.data[i].num
                // })
                break;
              case 6:
                detailed_type = "微课";
                // arrList.push({
                //   name: detailed_type,
                //   value: res.data[i].num
                // })
                break;
              case 7:
                detailed_type = "音频";
                arrList.push({
                  name: detailed_type,
                  value: res.data[i].num
                })
                break;
              case 8:
                number += res.data[i].num
                break;
              case 9:
                detailed_type = "ppt数量"
                number += res.data[i].num
                arrList.push({
                  name: detailed_type,
                  value: res.data[i].num
                })
                break;
              case 10:
                number += res.data[i].num
                break;
              case 11:
                detailed_type = "其他";
                // arrList.push({
                //   name: detailed_type,
                //   value: res.data[i].num
                // })
                break;
            }
            total += parseFloat(res.data[i].num)
          }
          // if (number > 0) {
          //   arrList.push({
          //     name: "ppt和富媒体等",
          //     value: number
          //   })
          // }

          this.resourcesMonth.dataList = arrList
          this.resourcesMonth.total = total
        }
      });
    },
    // 图12 本月课程新增情况
    coursesMonthDom() {
      this.$axios.post(this.$apiurls.quarterly_monthly_getQuarterZykAdd, { type: 3, year: 2022, quarter: 2 }, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.coursesMonth.dataList = []
          this.coursesMonth.dataList.push({
            name: '标准化课程',
            value: res.data.standardcCourse
          }, {
            name: '个性化课程',
            value: res.data.personalityCourse
          })
        }
      });
    },
    // 图14 本月资源访问情况
    accessMonthDom() {
      this.$axios.post(this.$apiurls.quarterly_monthly_getQuarterZykAdd, { type: 4, year: 2022, quarter: 2 }, {
        loading: false,
      }).then((res) => {
        if (res) {
          let arrList = []
          var transverse = []
          var total = 0

          for (let i = 0; i < res.data.length; i++) {

            arrList.push(res.data[i].num)
            transverse.push(res.data[i].date)
            total += parseFloat(res.data[i].num)
          }
          this.accessMonth.dataList = arrList
          this.accessMonth.transverseData = transverse
          this.accessMonth.legendList = ['资源访问']
          this.accessMonth.colorList = this.colorList
          this.accessMonth.total = total
        }
      });
    },

    // 图15 本季度课程访问情况
    visitsMonthDom() {
      this.$axios.post(this.$apiurls.quarterly_monthly_getQuarterZykAdd, { type: 5, year: 2022, quarter: 2 }, {
        loading: false,
      }).then((res) => {
        if (res) {
          var transverse = []
          var arrList = []
          var total = 0
          for (let i = 0; i < res.data.length; i++) {
            transverse.push(res.data[i].date)
            arrList.push(res.data[i].num)
            total += parseFloat(res.data[i].num)
          }
          this.visitsMonth.dataList = arrList
          this.visitsMonth.transverseData = transverse
          this.visitsMonth.legendList = ['课程访问']
          this.visitsMonth.colorList = this.colorList
          this.visitsMonth.total = total

        }
      });
    },
    // 图16 本月用户访问情况
    userAccessMonthDom() {
      this.$axios.post(this.$apiurls.quarterly_monthly_getQuarterZykAdd, { type: 6, year: 2022, quarter: 2 }, {
        loading: false,
      }).then((res) => {
        console.log(res, 121212);
        let teacherTotal = 0;
        let enterpriseTotal = 0;
        let studentTotal = 0;
        let socialTotal = 0
        let teacherNumArray = []
        let enterpriseNumArray = []
        let studentNumArray = []
        let socialNumArray = []
        var total = 0
        let transverse = []
        if (res) {

          for (let i = 0; i < res.data.teacherAction.length; i++) {
            teacherTotal += parseFloat(res.data.teacherAction[i].num)
            transverse.push(res.data.teacherAction[i].date)
            teacherNumArray.push(res.data.teacherAction[i].num)
          }
          for (let i = 0; i < res.data.studentAction.length; i++) {
            studentTotal += parseFloat(res.data.studentAction[i].num)
            enterpriseNumArray.push(res.data.studentAction[i].num)
          }
          for (let i = 0; i < res.data.enterpriseAction.length; i++) {
            enterpriseTotal += parseFloat(res.data.enterpriseAction[i].num)
            studentNumArray.push(res.data.enterpriseAction[i].num)
          }
          for (let i = 0; i < res.data.socialAction.length; i++) {
            socialTotal += parseFloat(res.data.socialAction[i].num)
            socialNumArray.push(res.data.socialAction[i].num)
          }
          let total = teacherTotal + studentTotal + enterpriseTotal + socialTotal
          this.userAccessMonth.dataList = [teacherNumArray, enterpriseNumArray, studentNumArray, socialNumArray]
          this.userAccessMonth.transverseData = transverse
          this.userAccessMonth.legendList = ['教师行为', '学生行为', '企业用户行为', '社会学习者行为']
          this.userAccessMonth.colorList = this.colorList
          this.userAccessMonth.total = total
        }
      });
    },
    // 图17 本季度用户访问时间段分布
    getLrmv2MonthBehaviorUserCourseLog() {
      this.$axios.post(this.$apiurls.report_monthly_getLrmv2MonthBehaviorUserCourseLog, {
        loading: false,
      }).then((res) => {
        if (res) {
          var arrList = []
          var total = 0
          for (let i = 0; i < res.data.length; i++) {
            arrList.push([res.data[i].behaviorOne, res.data[i].behaviorTwo, res.data[i].behaviorThree, res.data[i].behaviorFour, res.data[i].behaviorFive, res.data[i].behaviorSix, res.data[i].behaviorSeven, res.data[i].behaviorEight])
            total += parseFloat(res.data[i].behaviorOne) + parseFloat(res.data[i].behaviorTwo) + parseFloat(res.data[i].behaviorThree) + parseFloat(res.data[i].behaviorFour) + parseFloat(res.data[i].behaviorFive) + parseFloat(res.data[i].behaviorSix) + parseFloat(res.data[i].behaviorSeven) + parseFloat(res.data[i].behaviorEight)
          }
          this.behaviorUser.dataList = arrList
          this.behaviorUser.transverseData = ['00：00—03：00', '03：00—06：00', '06：00—09：00', '09：00—12：00', '12：00—15：00', '15：00—18：00', '18：00—21：00', '21：00—00：00']
          this.behaviorUser.legendList = ['教师行为', '学生行为', '企业用户行为', '社会学习者行为']
          this.behaviorUser.colorList = this.colorList
          this.behaviorUser.total = total
        }
      });
    },

    // 进度条上的百分比值转化
    teacherFormat() {
      return `${this.waterDrop.teacherNum}%`;
    },
    studentFormat() {
      return `${this.waterDrop.studentNum}%`;
    },
    resourceFormat() {
      return `${this.ben.noAccessResourceList}%`;
    },
    lastresourceFormat() {
      return `${this.LastMoth.noAccessResourceList}%`;
    },
    majorteacherFormat() {
      return `${this.waterDrop.majorteacherNum}%`;
    },
    majorstudentFormat() {
      return `${this.waterDrop.majorstudentNum}%`;
    },
    unitteacherFormat() {
      return `${this.waterDrop.unitteacherNum}%`;
    },
    unitstudentFormat() {
      return `${this.waterDrop.unitstudentNum}%`;
    }
  }
}
</script>

<style scoped>
.analysisReport {
  width: 100%;
  background: #fff;
}

h1,
h2,
h3,
h4,
h5,
p {
  margin: 0px;
  padding: 0px;
}

.analysisReport_box {
  width: 70%;
  margin: 0px auto;
}

.header_titles {
  display: flex;
  justify-content: center;
  flex-flow: column;
  color: #000;
  text-align: center;
  position: relative;
}

.header_titles h1 {
  font-size: 26px;
  font-weight: bold;
  color: #1d244e;
  line-height: 30px;
  margin-top: 41px;
}

.header_titles .monthly {
  font-size: 18px;
  font-weight: 400;
  color: #1d244e;
  line-height: 30px;
  margin-top: 6px;
}

.number_time {
  margin: 20px 0px;
}
.number_time div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #707f9d;
  font-size: 17px;
}

.number_time p {
  width: 100%;
  height: 1px;
  background: #707f9d;
  margin-top: 8px;
}
.number_time p:last-child {
  opacity: 0.5;
  margin-top: 4px;
}

.division {
  width: 100%;
  height: 40px;
  position: relative;
  clear: both;
}
.division span {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  background: #fff;
  font-weight: bold;
  font-size: 20px;
  color: #1d244e;
  font-size: 23px;
  padding: 0px 50px;
  line-height: 30px;
}

.chart_box {
  width: 100%;
  height: auto;
  margin-bottom: 60px;
  clear: both;
}

.chart_box h4 {
  font-weight: 700;
  font-size: 18px;
  color: #1d244e;
  /*text-indent: 40px;*/
  line-height: 30px;
}
.chart_box p {
  font-size: 17px;
  text-indent: 40px;
  line-height: 28px;
  color: #707f9d;
}

.chart_box .echartsHeight,
.layout,
.speed {
  width: 80%;
  height: calc(100vw / 1080 * 300);
  height: 400px;
  margin: 10px auto 0px;
}

.speed {
  width: 100%;
  height: auto;
}

.speed > div {
  width: 80%;
  font-size: 17px;
  color: #707f9d;
  line-height: 28px;
  margin: 20px auto;
}

.speed .el-col {
  margin-bottom: 15px;
}

.speed .el-col div {
  height: 40px;
  display: flex;
  align-items: center;
}

.chart_box .chart_name {
  text-align: center;
  font-size: 17px;
  color: #707f9d;
  clear: both;
}

.chart_box .notes {
  margin: 35px;
  line-height: 25px;
  font-size: 17px;
  color: #707f9d;
}

/* 布局 */
.layout {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.export {
  position: absolute;
  right: 10px;
  top: 10px;
}

.center {
  text-align: center;
}
.divorced {
  margin-top: 40px;
}

::v-deep .el-progress-bar__innerText {
  color: #000;
}
</style>


<style>
::-webkit-scrollbar {
  width: 10px !important;
  height: 14px;
  border-radius: 3px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background-color: #c1c1c1 !important;
  border-radius: 3px;
}
</style>